export default "__VITE_ASSET__0a1a87d2__"